export default "__VITE_ASSET__4f17932e__"